import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { injectDispatch } from '@ngrx/signals/events';
import {
  TextInputComponent,
  NumberInputComponent,
} from '@navstation-portal/shared/ui/components';
import { IsVisibleDirective } from '@navstation-portal/shared/ui/directives';
import {
  offshoreOperationalEvents,
  OffshoreReportStore,
  OffshoreOperationalFormStore,
  AbstractStoreConnectedSectionComponent,
} from '@navstation-portal/reporting/data-access/offshore-report';

@Component({
  selector: 're-miscellaneous',
  templateUrl: './miscellaneous.component.html',
  styleUrl: './miscellaneous.component.css',
  imports: [
    FormsModule,
    TextInputComponent,
    NumberInputComponent,
    IsVisibleDirective,
  ],
})
export class MiscellaneousComponent extends AbstractStoreConnectedSectionComponent {
  tabId = 'operational';
  sectionId = 'miscellaneous';
  events = injectDispatch(offshoreOperationalEvents);
  offshoreReportStore = inject(OffshoreReportStore);
  offshoreOperationalStore = inject(OffshoreOperationalFormStore);
}
